import JPG_One from "../../../assets/images/raster/pages/es/Guides/Guides_1.jpg";
import WEBP_One from "../../../assets/images/raster/pages/es/Guides/Guides_1.webp";

import JPG_Two from "../../../assets/images/raster/pages/es/Guides/Guides_2.jpg";
import WEBP_Two from "../../../assets/images/raster/pages/es/Guides/Guides_2.webp";

import JPG_Three from "../../../assets/images/raster/pages/es/Guides/Guides_3.jpg";
import WEBP_Three from "../../../assets/images/raster/pages/es/Guides/Guides_3.webp";

import { URL_LABEL } from "../index.content";

const IDEA_GUIDES_LIST = [
  {
    screen: {
      PNG: JPG_One,
      WEBP: WEBP_One,
    },
    title: `Cómo ganar dinero en Amazon en ${process.env.YEAR}`,
    text: "Descubre técnicas y estrategias comprobadas que te permitirán construir un negocio exitoso en Amazon",
    href: `https://amzscout.net/blog/how-to-make-money-on-amazon-a-step-by-step-guide/?${URL_LABEL}`,
  },
  {
    screen: {
      PNG: JPG_Two,
      WEBP: WEBP_Two,
    },
    title: `Cómo encontrar productos para vender en Amazon en ${process.env.YEAR} paso a paso`,
    text: `Lee nuestra guía para aprender a encontrar los productos más rentables para vender en Amazon`,
    href: `https://amzscout.net/blog/how-to-find-perfect-products-to-sell-on-amazon/?${URL_LABEL}`,
  },
  {
    screen: {
      PNG: JPG_Three,
      WEBP: WEBP_Three,
    },
    title: "Negocio Amazon FBA: Guía en 7 pasos de un experto de Amazon",
    text: "Aprende la lista de 7 pasos que usó el exitoso vendedor de Amazon Alex Shelton para construir su propio imperio de comercio electrónico",
    href: `https://amzscout.net/blog/amazon-fba-business/?${URL_LABEL}`,
  }
];

export default IDEA_GUIDES_LIST;
